import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Consulting";
const heroImage = "https://net-basis.net/Bilder/ict-market-entry-consulting-strategy-dach.webp";
const heroAlt = "Geschäftsleute prüfen Marktdaten für Eintritts-, Vertriebs- und Marketingstrategien im DACH-Markt.";
const heroClaimLine1 = "Sicher auf";
const heroClaimLine2 = "neuen Märkten!";
const claimText = "Ihr strategischer Beratungspartner für den zielgerichteten Markteintritt in der DACH-Region. Wir transformieren fundiertes Sachwissen in praktikable Lösungen, um Ihre internationale Geschäftstätigkeit effizient und nachhaltig zu erweitern.";
const benefitsTitle = "Wie Sie von unserer Expertise im Bereich __Consulting__ profitieren:";
const p1Text = "NetBasis International bietet ein umfassendes Spektrum an Beratungsleistungen. Durch fundiertes Know-how und ein tiefes Verständnis für das Geschäft unserer Partner entwickeln wir maßgeschneiderte Strategien zur erfolgreichen Expansion und schnellen Erreichung Ihrer Geschäftsziele.";
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Fundierte Evaluierung der spezifischen Geschäftspotenziale in den Zielmärkten",
  "Strategische Festlegung des optimalen Markteintritts",
  "Passgenaue Anpassung an die umfeldbedingten Unterschiede der neuen Wirtschaftsräume",
  "Kompetente Beratung bei der Definition der geschäftlichen Ziele unserer Herstellerpartner",
  "Erstellung zielführender Vertriebs- und Marketingpläne zur sicheren Zielerreichung",
  "Operative Unterstützung bei der Planung und Umsetzung aller notwendigen Schritte",
  "Praxisnahe Managementberatung bei interkulturellen Integrationsfragen",
  "Entwicklung durchdachter Verhandlungsstrategien und Begleitung bei deren Realisierung",
  "Effiziente Koordination und Zusammenarbeit mit potenziellen Geschäftspartnern wie Herstellern, Händlern oder Wiederverkäufern",
];

export default function ConsultingDePage() {
  const strongName = COMPANY_NAME;
  const p1Parts = p1Text.split(strongName);

  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Unternehmensberatung | NetBasis International"
        description="Strategische Beratung zur Optimierung Ihrer Vertriebsstrukturen und zur nachhaltigen Etablierung ausländischer Marken."
        ogUrl="https://net-basis.net/de/services/consulting"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[8%] md:pt-[5%] lg:pt-[5%] pointer-events-none">
                <p
                  className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center globus-text-slide"
                  style={{
                    fontFamily: '"Open Sans", sans-serif',
                  }}
                >
                  <span className="block md:hidden">{heroClaimLine1}</span>
                  <span className="block md:hidden">{heroClaimLine2}</span>
                  <span className="hidden md:block">{heroClaimLine1} {heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <h1 className="text-sm md:text-base font-semibold text-foreground-950 mb-4 font-sans">
                {claimText}
              </h1>
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{strongName}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            {/* Benefits heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Benefits with checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}